import { useFormContext } from "react-hook-form"

import { formatDateForDisplay } from "utils/dates"
import { ScrollTrigger } from "utils/gsap"

import type { Availability } from "hooks/useAvailability"

const FrontendTime: React.FC<{ availability: Availability }> = ({
  availability
}) => {
  const rhf = useFormContext()
  // Less than 1 incase of a negative number
  if (availability.slots < 1) return null
  return (
    <li
      className={`${
        availability.dateTime.toISOString() === rhf.watch("installDate") &&
        "bg-gray-200"
      } cursor-pointer border-2 border-gray-200 text-center bg-white hover:bg-gray-200 !select-none`}
      onClick={() => {
        rhf.setValue("installDate", availability.dateTime.toISOString())
        ScrollTrigger.refresh(true)
      }}
    >
      <div className="!p-2">
        {formatDateForDisplay(availability.dateTime, null)}
      </div>
    </li>
  )
}

export default FrontendTime
